module.exports = __webpack_public_path__ + "img/panela.860ea0f6.jpeg";